import { render } from "./FactureClientView.vue?vue&type=template&id=76225462&scoped=true"
import script from "./FactureClientView.vue?vue&type=script&lang=js"
export * from "./FactureClientView.vue?vue&type=script&lang=js"

import "./FactureClientView.vue?vue&type=style&index=0&id=76225462&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76225462"]])

export default __exports__